<script lang="ts" setup>
</script>

<template>
  <section class="page-about-description mt-80px">
    <div class="about-description__container box-border text-justify container">
      <h2 class="m-0 text-center text-32px font-medium">{{ $t('about.title') }}</h2>
      <div class="mt-32px">
        <p>{{ $t('about.infoAbout.briefIntroduction1') }}</p>
        <p>{{ $t('about.infoAbout.briefIntroduction2') }}</p>
        <p>{{ $t('about.infoAbout.briefIntroduction3') }}</p>
        <p>{{ $t('about.infoAbout.briefIntroduction4') }}</p>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-about-description {
  .about-description__container {
    padding: 48px 64px;
    background-color: #fff;
    border: 1px solid rgba(154, 158, 166, 0.1);
    border-radius: 4px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.04);

    p {
      font-size: 16px;
      line-height: 24px;
      text-indent: 2em;

      @apply m-0;
    }
  }
}
</style>
